import {
  IStudentSubjectGrade,
  IStudentSubjectGrades,
} from "../../../../models/student/studentGrades";
import { useEffect } from "react";
import { setStudentSubjectGrades } from "../../../../store/slices/student/studentSubjectGrades";
import { getStudentSubjectGradeDetails } from "../../../../action/student/studentSubjectGradesActionCreator";
import { getCurrentUserData } from "../../../../action/user/userProfileActionCreator";
import { connect, useDispatch } from "react-redux";

const Grades = (props: IStudentSubjectGrade) => {
  const { getSubjectGrades, subjectGrades, selectedTerm, userInfo } = props;
  const dispatch = useDispatch();

  useEffect(() => {
    if (userInfo && userInfo?.id) {
      getSubjectGrades(selectedTerm, userInfo?.id);
    }
  }, [selectedTerm, userInfo]);

  useEffect(() => {
    return () => {
      dispatch(setStudentSubjectGrades([]));
    };
  }, []);

  return (
    <>
      <div className="card-wrap mb-3">
        <div className="title">
          <h2>Grades</h2>
          <a
            href="https://www.w3schools.com/"
            className="btn-link"
            target="_blank"
          >
            View All
          </a>
        </div>
        <div className="table-card grade-list-scroll mt-2">
          <table>
            <thead>
              <tr>
                <th>Course</th>
                <th>Grade</th>
              </tr>
            </thead>
            <tbody>
              {subjectGrades?.map((grade: IStudentSubjectGrades) => (
                <tr>
                  <td>{grade.subject}</td>
                  <td
                    className={
                      grade.grade === "A"
                        ? "grade-high"
                        : grade.grade === "B"
                          ? "grade-mid"
                          : grade.grade === "C"
                            ? "grade-low"
                            : "grade-not"
                    }
                  >
                    <span>{grade.grade}</span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

const mapDispatchToProps = {
  getSubjectGrades: (semesterId: number, studentId: string) =>
    getStudentSubjectGradeDetails(semesterId, studentId),
};

function mapStateToProps(state: any) {
  return {
    subjectGrades: state.studentSubjectGrades.grades,
    userInfo: state.userDetails.userProfileData,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Grades);
